import type { AsyncState as AsyncStateKind } from "@gui/widgets/A11y";

interface AsyncFlags {
	loading: boolean;
	error?: string | null;
	isEmpty: boolean;
	/** Whether this surface's own load failed. Defaults to "there is an error". */
	loadFailed?: boolean;
}

/**
 * Which single state a data-backed surface is in. Loading outranks everything, and a failure
 * only takes over the surface when there is nothing to show: a failed *action* on a populated
 * page must not blank the rows the user was working on.
 *
 * `loadFailed` separates "this list could not be loaded" from "there is an error to report".
 * A page whose one error message also carries failures from elsewhere (another tab's request,
 * a batch action) passes it, so a list that loaded fine and is empty still reads as empty.
 */
export function resolveAsyncState({ loading, error, isEmpty, loadFailed }: AsyncFlags): AsyncStateKind {
	if (loading) return "loading";
	if (!isEmpty) return "ready";
	return (loadFailed ?? Boolean(error)) ? "error" : "empty";
}
